/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Asset properties that can be used for filtering.
 * * If modeOfOperation is used, set the value to INSTALLED_MODE to filter assets that are attached to a battery. Otherwise, for assets not attached to a battery use STANDALONE_MODE and for assets working as a charger use CHARGER.
 * * If subscriptionType is used, set the value to Premium to filter assets having Premium as a subscription type.
 * Set the value to Standard to filter assets having Standard as a subscription type.
 * Set the value to Economy to filter assets having Economic as a subscription type.
 * * If assetChargingStatus is used, set the value to Charging to filter assets that are CHARGING. Otherwise, for assets that are not charging use NOT_CHARGING.
 * * If health is used, set the value to Good to filter assets that have good battery health.
 * Set the value to Bad to filter assets that have bad battery health.
 * Set the value to Critical to filter assets that have critical battery health.
 *
 */
export var AssetPropertiesForFiltering;
(function (AssetPropertiesForFiltering) {
    AssetPropertiesForFiltering["MAKE"] = "make";
    AssetPropertiesForFiltering["SERIAL_NUMBER"] = "serialNumber";
    AssetPropertiesForFiltering["MODE_OF_OPERATION"] = "modeOfOperation";
    AssetPropertiesForFiltering["MODEL"] = "model";
    AssetPropertiesForFiltering["PRODUCT_FAMILY"] = "productFamily";
    AssetPropertiesForFiltering["SUBSCRIPTION_TYPE"] = "subscriptionType";
    AssetPropertiesForFiltering["BATTERY_HEALTH"] = "batteryHealth";
    AssetPropertiesForFiltering["ASSET_CHARGING_STATUS"] = "assetChargingStatus";
})(AssetPropertiesForFiltering || (AssetPropertiesForFiltering = {}));
